import React from 'react';
import {
    NavLink,
    Outlet,
    useNavigate
} from 'react-router-dom';
import './adminLayout.css';
import API_BASE_URL from '../../../config/api';

const AdminLayout = () => {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await fetch(
                `${API_BASE_URL}/api/admin/logout`,
                {
                    method: 'POST',
                    credentials: 'include'
                }
            );

            navigate('/admin');
        } catch (error) {
            console.error(
                '로그아웃 오류:',
                error
            );

            alert('로그아웃 중 오류가 발생했습니다.');
        }
    };

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <div className="admin-sidebar-logo">
                    <strong>
                        MTMEDIA
                    </strong>

                    <span>
                        ADMIN
                    </span>
                </div>

                <nav className="admin-sidebar-nav">
                    <NavLink
                        to="/admin/dashboard"
                        className={({ isActive }) =>
                            isActive
                                ? 'admin-nav-item active'
                                : 'admin-nav-item'
                        }
                    >
                        <i className="mdi mdi-view-dashboard-outline"></i>

                        <span>
                            대시보드
                        </span>
                    </NavLink>

                    <NavLink
                        to="/admin/inquiries"
                        className={({ isActive }) =>
                            isActive
                                ? 'admin-nav-item active'
                                : 'admin-nav-item'
                        }
                    >
                        <i className="mdi mdi-email-outline"></i>

                        <span>
                            견적문의 관리
                        </span>
                    </NavLink>

                    <NavLink
                        to="/admin/portfolios"
                        className={({ isActive }) =>
                            isActive
                                ? 'admin-nav-item active'
                                : 'admin-nav-item'
                        }
                    >
                        <i className="mdi mdi-image-multiple-outline"></i>

                        <span>
                            시공사례 관리
                        </span>
                    </NavLink>

                    <NavLink
                        to="/admin/notices"
                        className={({ isActive }) =>
                            isActive
                                ? 'admin-nav-item active'
                                : 'admin-nav-item'
                        }
                    >
                        <i className="mdi mdi-bullhorn-outline"></i>

                        <span>
                            공지사항 관리
                        </span>
                    </NavLink>

                    <NavLink
                        to="/admin/faqs"
                        className={({ isActive }) =>
                            isActive
                                ? 'admin-nav-item active'
                                : 'admin-nav-item'
                        }
                    >
                        <i className="mdi mdi-help-circle-outline"></i>

                        <span>
                            FAQ 관리
                        </span>
                    </NavLink>
                </nav>

                <div className="admin-sidebar-bottom">
                    <NavLink
                        to="/admin/account"
                        className="admin-nav-item"
                    >
                        <i className="mdi mdi-account-cog-outline"></i>

                        <span>
                            계정 설정
                        </span>
                    </NavLink>

                    <button
                        type="button"
                        className="admin-logout-button"
                        onClick={handleLogout}
                    >
                        <i className="mdi mdi-logout"></i>

                        <span>
                            로그아웃
                        </span>
                    </button>
                </div>
            </aside>

            <div className="admin-main">
                <header className="admin-topbar">
                    <div>
                        <span>
                            MTMEDIA Website Management
                        </span>
                    </div>

                    <div className="admin-topbar-user">
                        <div className="admin-user-icon">
                            <i className="mdi mdi-account"></i>
                        </div>

                        <div>
                            <strong>
                                관리자
                            </strong>

                            <span>
                                Administrator
                            </span>
                        </div>
                    </div>
                </header>

                <main className="admin-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;